export default __webpack_public_path__ + "static/media/fad-filter-bypass.5fa973e0.svg";